import { create } from "zustand";

const botResponses = [
    "Merci pour votre message! Comment puis-je vous aider aujourd'hui?",
    "C'est une excellente question! Laissez-moi réfléchir...",
    "Je comprends votre demande. Voici ce que je peux vous dire:",
    "Intéressant! Pourriez-vous m'en dire un peu plus?",
    "Je suis là pour vous aider. Que souhaitez-vous savoir?",
    "D'accord, je vois. Voici ma réponse:",
    "Parfait! Je peux certainement vous aider avec cela.",
    "C'est noté! Autre chose que je puisse faire pour vous?",
];

const getRandomDelay = () => Math.floor(Math.random() * 1000) + 1000;

const getRandomResponse = (userMessage) => {
    if (
        userMessage.toLowerCase().includes("bonjour") ||
        userMessage.toLowerCase().includes("salut")
    ) {
        return "Bonjour! Je suis ravi de vous parler. Comment puis-je vous aider?";
    }
    if (userMessage.toLowerCase().includes("merci")) {
        return "De rien! C'est un plaisir de vous aider. N'hésitez pas si vous avez d'autres questions!";
    }
    if (
        userMessage.toLowerCase().includes("aide") ||
        userMessage.toLowerCase().includes("help")
    ) {
        return "Bien sûr, je suis là pour vous aider! Posez-moi n'importe quelle question.";
    }
    return botResponses[Math.floor(Math.random() * botResponses.length)];
};

export const useChatStore = create((set, get) => ({
    isOpen: false,
    messages: [
        {
            id: Date.now(),
            text: "Bonjour! Je suis votre assistant virtuel. Comment puis-je vous aider aujourd'hui?",
            sender: "bot",
            timestamp: new Date(),
        },
    ],
    isTyping: false,

    toggleChat: () => set((state) => ({ isOpen: !state.isOpen })),

    addMessage: (text, sender) => {
        const message = {
            id: Date.now() + Math.random(),
            text,
            sender,
            timestamp: new Date(),
        };
        set((state) => ({ messages: [...state.messages, message] }));
    },

    sendMessage: (text) => {
        const { addMessage } = get();

        addMessage(text, "user");

        set({ isTyping: true });

        const delay = getRandomDelay();
        setTimeout(() => {
            const response = getRandomResponse(text);
            addMessage(response, "bot");
            set({ isTyping: false });
        }, delay);
    },

    clearMessages: () => set({ messages: [] }),
}));
